export globalSettings from './global/triggers';
export userSettings from './user/triggers';



// WEBPACK FOOTER //
// ./src/frontend/modules/settings/triggers.js